"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loop = void 0;
const three_1 = require("three");
const TWEEN = __importStar(require("@tweenjs/tween.js"));
const clock = new three_1.Clock();
class Loop {
    constructor(camera, scene, renderer, controls, cssRenderer) {
        this.camera = camera;
        this.scene = scene;
        this.renderer = renderer;
        this.controls = controls;
        this.cssRenderer = cssRenderer;
        this._updatables = [];
    }
    get updatables() { return this._updatables; }
    set updatables(updatables) { this._updatables = updatables; }
    dispose() {
        this.updatables = [];
        delete this.controls;
        delete this.cssRenderer;
        delete this.renderer;
    }
    // Start animating
    start() {
        var _a;
        (_a = this.renderer) === null || _a === void 0 ? void 0 : _a.setAnimationLoop(() => {
            var _a;
            this.tick(); // Tell every animated object to tick forward one frame
            this.onUpdate(); // Perform any custom update actions
            (_a = this.renderer) === null || _a === void 0 ? void 0 : _a.render(this.scene, this.camera); // Render a frame
        });
    }
    // Stop animationg
    stop() {
        var _a;
        (_a = this.renderer) === null || _a === void 0 ? void 0 : _a.setAnimationLoop(null);
    }
    // Tick
    tick() {
        // Only call the getDelta function once per frame!
        const delta = clock.getDelta();
        // Code to update animations will go here
        for (const object of this.updatables) {
            // object.tick(delta);
        }
    }
    // Custom update actions
    onUpdate() {
        var _a, _b;
        (_a = this.controls) === null || _a === void 0 ? void 0 : _a.update();
        (_b = this.cssRenderer) === null || _b === void 0 ? void 0 : _b.render(this.scene, this.camera); // annotation popover movement
        TWEEN.update(); // object movement from a to b update
    }
}
exports.Loop = Loop;
